(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    const shell = document.querySelector('[data-cart-drawer]');
    if (!shell || shell.dataset.initialized === 'true') return;
    shell.dataset.initialized = 'true';

    const drawer = shell.querySelector('.cart-drawer');
    const itemsEl = shell.querySelector('[data-cart-items]');
    const subtotalEl = shell.querySelector('[data-cart-subtotal]');
    const statusEl = shell.querySelector('[data-cart-status]');
    const titleEl = shell.querySelector('#cart-drawer-title');
    const currency = shell.dataset.currency || 'USD';
    let lastFocused = null;

    const money = (cents) =>
      new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency,
      }).format((cents || 0) / 100);

    const escapeHTML = (value) =>
      String(value || '').replace(/[&<>"']/g, (char) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      })[char]);

    const itemCountText = (count) => `${count} ${count === 1 ? shell.dataset.itemSingular : shell.dataset.itemPlural}`;

    const setStatus = (message) => {
      if (!statusEl) return;
      statusEl.textContent = message || '';
    };

    const setCartCount = (count) => {
      document.querySelectorAll('[data-cart-count]').forEach((countEl) => {
        countEl.textContent = count;
        countEl.hidden = count < 1;
      });
    };

    const updateTitle = (count) => {
      if (titleEl) titleEl.textContent = itemCountText(count);
    };

    const renderItems = (cart) => {
      if (!itemsEl) return;
      updateTitle(cart.item_count);
      setCartCount(cart.item_count);
      if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

      if (!cart.items.length) {
        itemsEl.innerHTML = `<p class="cart-drawer__empty">${shell.dataset.emptyText}</p>`;
        return;
      }

      itemsEl.innerHTML = cart.items
        .map((item) => {
          const title = escapeHTML(item.product_title);
          const variantTitle = escapeHTML(item.variant_title);
          const url = escapeHTML(item.url);
          const key = escapeHTML(item.key);
          const image = item.image
            ? `<img src="${escapeHTML(item.image)}" alt="${title}" loading="lazy">`
            : '';
          const variant = item.variant_title && item.variant_title !== 'Default Title'
            ? `<p class="cart-drawer__variant">${variantTitle}</p>`
            : '';
          return `
            <article class="cart-drawer__item" data-cart-line-key="${key}">
              <a class="cart-drawer__media" href="${url}">${image}</a>
              <div class="cart-drawer__item-info">
                <a class="cart-drawer__item-title" href="${url}">${title}</a>
                ${variant}
                <p class="cart-drawer__line-price">${money(item.final_line_price)}</p>
                <div class="cart-drawer__line-actions">
                  <div class="cart-drawer__quantity">
                    <button type="button" data-cart-quantity data-quantity="${item.quantity - 1}" aria-label="${shell.dataset.decreaseLabel}">-</button>
                    <span>${item.quantity}</span>
                    <button type="button" data-cart-quantity data-quantity="${item.quantity + 1}" aria-label="${shell.dataset.increaseLabel}">+</button>
                  </div>
                  <button type="button" class="cart-drawer__remove" data-cart-remove>${shell.dataset.removeLabel}</button>
                </div>
              </div>
            </article>
          `;
        })
        .join('');
    };

    const fetchCart = () => fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((res) => res.json());

    const refreshCart = () => fetchCart().then((cart) => {
      renderItems(cart);
      return cart;
    });

    const openDrawer = () => {
      lastFocused = document.activeElement;
      shell.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      drawer.focus();
    };

    const closeDrawer = () => {
      shell.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    };

    const changeLine = (key, quantity) =>
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      }).then((res) => {
        if (!res.ok) throw new Error(shell.dataset.errorText);
        return res.json();
      });

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-add-to-cart-form]');
      if (!form) return;
      event.preventDefault();
      setStatus('');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      })
        .then((res) => {
          if (!res.ok) throw new Error(shell.dataset.errorText);
          return refreshCart();
        })
        .then(openDrawer)
        .catch((error) => setStatus(error.message || shell.dataset.errorText));
    });

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-cart-trigger]');
      if (trigger) {
        event.preventDefault();
        refreshCart().then(openDrawer).catch(() => openDrawer());
        return;
      }

      if (event.target.closest('[data-cart-close]')) {
        closeDrawer();
        return;
      }

      const action = event.target.closest('[data-cart-quantity], [data-cart-remove]');
      if (!action) return;
      const item = action.closest('[data-cart-line-key]');
      if (!item) return;
      const quantity = action.matches('[data-cart-remove]') ? 0 : Number(action.dataset.quantity);
      setStatus('');
      changeLine(item.dataset.cartLineKey, quantity)
        .then(renderItems)
        .catch((error) => setStatus(error.message || shell.dataset.errorText));
    });

    document.addEventListener('keydown', (event) => {
      if (!shell.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        closeDrawer();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.querySelectorAll('[data-collection-section]').forEach((section) => {
    section.classList.add('is-load-more-ready');
  });

  document.addEventListener('change', (event) => {
    const sortControl = event.target.closest('[data-collection-sort]');

    if (!sortControl) {
      return;
    }

    sortControl.form.submit();
  });

  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-collection-filter-close]');

    if (!closeButton) {
      return;
    }

    closeButton.closest('details').removeAttribute('open');
  });

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-collection-load-more]');

    if (!trigger) {
      return;
    }

    event.preventDefault();

    const section = trigger.closest('[data-collection-section]');
    const grid = section.querySelector('[data-collection-grid]');
    const pagination = section.querySelector('[data-collection-pagination]');
    const nextUrl = trigger.getAttribute('href');
    const requestUrl = new URL(nextUrl, window.location.origin);

    requestUrl.searchParams.set('section_id', section.dataset.sectionId);
    trigger.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(requestUrl.toString());
      const html = await response.text();
      const nextDocument = new DOMParser().parseFromString(html, 'text/html');
      const nextGrid = nextDocument.querySelector('[data-collection-grid]');
      const nextTrigger = nextDocument.querySelector('[data-collection-load-more]');

      Array.from(nextGrid.children).forEach((item) => {
        grid.appendChild(item);
      });

      if (nextTrigger) {
        trigger.setAttribute('href', nextTrigger.getAttribute('href'));
        trigger.removeAttribute('aria-busy');
      } else {
        pagination.remove();
      }
    } catch (error) {
      window.location.href = nextUrl;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var modals = document.querySelectorAll('[data-contact-modal]');
    if (!modals.length) return;

    var lastTrigger = null;

    function getFocusable(container) {
      return container.querySelectorAll(
        'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
    }

    function openModal(modal, trigger) {
      if (!modal) return;
      lastTrigger = trigger || lastTrigger;
      modal.hidden = false;
      document.body.style.overflow = 'hidden';

      var focusTarget = modal.querySelector('[data-contact-auto-open]')
        ? modal.querySelector('.footer-contact__success, .footer-contact__field input, .errors')
        : modal.querySelector('.footer-contact__field input, .footer-contact__close');

      if (focusTarget) {
        focusTarget.focus();
      }
    }

    function closeModal(modal) {
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      document.body.style.overflow = '';

      if (lastTrigger) {
        lastTrigger.focus();
      }
    }

    modals.forEach(function (modal) {
      if (modal.querySelector('[data-contact-auto-open]')) {
        openModal(modal);
      }
    });

    document.addEventListener('click', function (event) {
      var openTrigger = event.target.closest('[data-contact-open]');
      if (openTrigger) {
        var controlsId = openTrigger.getAttribute('aria-controls');
        var modal = controlsId ? document.getElementById(controlsId) : document.querySelector('[data-contact-modal]');
        event.preventDefault();
        openModal(modal, openTrigger);
        return;
      }

      var closeTrigger = event.target.closest('[data-contact-close]');
      if (closeTrigger) {
        var modalToClose = closeTrigger.closest('[data-contact-modal]');
        event.preventDefault();
        closeModal(modalToClose);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;

      modals.forEach(function (modal) {
        if (!modal.hidden) {
          closeModal(modal);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('[data-header-root]');
    if (!header) return;

    const section = header.closest('.shopify-section');
    const toggle = section?.querySelector('.site-header__toggle');
    const menu = section?.querySelector('.site-header__menu');
    const tracksScroll =
      header.classList.contains('site-header--sticky') || header.classList.contains('site-header--overlay');
    const scrollThreshold = 8;
    let scrollTicking = false;

    const countsForOffset = () => {
      return header.classList.contains('site-header--sticky') || header.classList.contains('site-header--overlay');
    };

    const getScrollY = () => {
      return window.scrollY || document.documentElement.scrollTop || 0;
    };

    const updateStickyHeight = () => {
      const height = countsForOffset() ? `${header.offsetHeight}px` : '0px';
      document.documentElement.style.setProperty('--header-sticky-height', height);
    };

    const updateScrollState = () => {
      if (!tracksScroll) return;

      const scrolled = getScrollY() > scrollThreshold;
      header.classList.toggle('site-header--scrolled', scrolled);
      updateStickyHeight();
    };

    const onScroll = () => {
      if (!tracksScroll || scrollTicking) return;

      scrollTicking = true;
      window.requestAnimationFrame(() => {
        updateScrollState();
        scrollTicking = false;
      });
    };

    updateStickyHeight();
    if (tracksScroll) {
      updateScrollState();
      window.addEventListener('scroll', onScroll, { passive: true });
      document.addEventListener('scroll', onScroll, { passive: true });
    }

    window.addEventListener('resize', updateStickyHeight, { passive: true });

    if (toggle && menu) {
      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') === 'true';
        const nextExpanded = !expanded;
        toggle.setAttribute('aria-expanded', String(nextExpanded));
        menu.classList.toggle('is-open', nextExpanded);
        if (window.matchMedia('(min-width: 768px)').matches) {
          menu.style.display = nextExpanded ? 'inline-flex' : 'none';
        } else {
          menu.style.display = '';
        }
        window.requestAnimationFrame(updateStickyHeight);
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-waitlist-cta]').forEach((trigger) => {
    if (trigger.dataset.waitlistCtaBound === 'true') return;

    trigger.dataset.waitlistCtaBound = 'true';
    trigger.addEventListener('click', (event) => {
      event.preventDefault();

      const target = document.getElementById('featured-collection');
      if (!target) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });

      window.setTimeout(
        () => {
          const emailInput = target.querySelector('[data-waitlist-email]');
          if (!emailInput) return;

          try {
            emailInput.focus({ preventScroll: true });
          } catch (error) {
            emailInput.focus();
          }
        },
        reduceMotion ? 0 : 650
      );
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ingredient-science"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bodyScrollLockCount = 0;
    var bodyScrollLockedY = 0;

    function lockBodyScroll() {
      if (bodyScrollLockCount === 0) {
        bodyScrollLockedY = window.scrollY || window.pageYOffset || 0;
        document.body.style.position = 'fixed';
        document.body.style.top = '-' + bodyScrollLockedY + 'px';
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
      }
      bodyScrollLockCount++;
    }

    function unlockBodyScroll() {
      bodyScrollLockCount--;
      if (bodyScrollLockCount < 0) {
        bodyScrollLockCount = 0;
      }

      if (bodyScrollLockCount !== 0) {
        return;
      }

      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, bodyScrollLockedY);
    }

    function initIngredientScience(root) {
      if (root.dataset.ingredientScienceReady === 'true') return;
      root.dataset.ingredientScienceReady = 'true';

      var dialog = root.querySelector('[data-ingredient-dialog]');
      var detail = root.querySelector('[data-ingredient-detail]');
      var closeBtn = root.querySelector('[data-ingredient-close]');
      var backBtn = root.querySelector('[data-ingredient-back]');
      var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-ingredient-tile]'));
      var templates = Array.prototype.slice.call(root.querySelectorAll('[data-ingredient-template]'));
      var chips = Array.prototype.slice.call(root.querySelectorAll('[data-ingredient-filter]'));
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-ingredient-grid] > li'));
      var status = root.querySelector('[data-ingredient-filter-status]');
      var filterCopy = root.querySelector('[data-ingredient-filter-copy]');
      var filterDescriptions = Array.prototype.slice.call(
        root.querySelectorAll('[data-ingredient-filter-description]')
      );
      var filterResultsTemplate = root.getAttribute('data-filter-results-template') || '';
      var labelByKey = {};
      var lastFocusedTile = null;

      if (!dialog || !detail || !tiles.length) return;

      function applyFilter(handle) {
        var activeHandle = handle || 'all';
        var count = 0;

        items.forEach(function (item) {
          var tags = (item.getAttribute('data-benefit-tags') || '').split(/\s*,\s*/);
          var match = tags.indexOf(activeHandle) !== -1;
          item.hidden = !match;
          if (match) count++;
        });

        chips.forEach(function (chip) {
          var isActive = chip.getAttribute('data-ingredient-filter') === activeHandle;
          chip.classList.toggle('is-active', isActive);
          chip.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        if (status && filterResultsTemplate) {
          status.textContent = filterResultsTemplate.replace('__count__', String(count));
        }

        if (filterCopy) {
          var hasVisibleDescription = false;

          filterDescriptions.forEach(function (description) {
            var matches = description.getAttribute('data-ingredient-filter-description') === activeHandle;
            description.hidden = !matches;
            if (matches) {
              hasVisibleDescription = true;
            }
          });

          filterCopy.hidden = activeHandle === 'all' || !hasVisibleDescription;
        }

      }

      tiles.forEach(function (tile) {
        var key = tile.getAttribute('data-ingredient-key');
        var name = tile.querySelector('.ingredient-science__card-name');
        if (key && name) {
          labelByKey[key] = name.textContent.trim();
        }
      });

      function render(key) {
        var template = null;

        templates.forEach(function (entry) {
          if (entry.getAttribute('data-ingredient-key') === key) {
            template = entry;
          }
        });

        if (!template) return;

        var fragment = template.content.cloneNode(true);
        var existingContent = detail.querySelector('[data-ingredient-content]');
        if (existingContent) {
          existingContent.remove();
        }

        var contentWrap = document.createElement('div');
        contentWrap.setAttribute('data-ingredient-content', '');
        contentWrap.appendChild(fragment);
        detail.appendChild(contentWrap);

        var heading = contentWrap.querySelector('.ingredient-science__detail-heading');
        var labelledBy = dialog.getAttribute('aria-labelledby');
        if (heading && labelledBy) {
          heading.id = labelledBy;
        }

        contentWrap.querySelectorAll('[data-ingredient-pair]').forEach(function (chip) {
          var pairKey = chip.getAttribute('data-ingredient-pair');
          if (labelByKey[pairKey]) {
            chip.textContent = labelByKey[pairKey];
          }

          chip.addEventListener('click', function () {
            open(pairKey);
          });
        });

        tiles.forEach(function (tile) {
          tile.classList.toggle('is-active', tile.getAttribute('data-ingredient-key') === key);
        });
      }

      function open(key) {
        lastFocusedTile = document.activeElement;
        render(key);
        if (!dialog.open) {
          lockBodyScroll();
          dialog.showModal();
        }

        var heading = detail.querySelector('.ingredient-science__detail-heading');
        if (heading) {
          heading.setAttribute('tabindex', '-1');
          heading.focus();
        } else if (backBtn) {
          backBtn.focus();
        }
      }

      function close() {
        if (dialog.open) {
          dialog.close();
        }
      }

      tiles.forEach(function (tile) {
        tile.addEventListener('click', function () {
          open(tile.getAttribute('data-ingredient-key'));
        });
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', close);
      }

      if (backBtn) {
        backBtn.addEventListener('click', close);
      }

      dialog.addEventListener('click', function (event) {
        var rect = dialog.getBoundingClientRect();
        var inside =
          event.clientY >= rect.top &&
          event.clientY <= rect.bottom &&
          event.clientX >= rect.left &&
          event.clientX <= rect.right;
        if (!inside) {
          close();
        }
      });

      dialog.addEventListener('close', function () {
        unlockBodyScroll();
        tiles.forEach(function (tile) {
          tile.classList.remove('is-active');
        });

        if (lastFocusedTile && typeof lastFocusedTile.focus === 'function') {
          try {
            lastFocusedTile.focus({ preventScroll: true });
          } catch (error) {
            lastFocusedTile.focus();
          }
        }
      });

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          applyFilter(chip.getAttribute('data-ingredient-filter'));
        });
      });

      var filters = root.querySelector('.ingredient-science__filters');
      var defaultFilter = filters && filters.getAttribute('data-default-filter');
      if (!defaultFilter) {
        defaultFilter = 'all';
      }
      applyFilter(defaultFilter);
    }

    function bootIngredientScience() {
      document.querySelectorAll('[data-ingredient-science]').forEach(initIngredientScience);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootIngredientScience);
    } else {
      bootIngredientScience();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.matches('[data-ingredient-science]')
        ? event.target
        : event.target.querySelector('[data-ingredient-science]');
      if (section) initIngredientScience(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const galleries = document.querySelectorAll('[data-product-gallery]');
    if (!galleries.length) return;

    galleries.forEach((gallery) => {
      const slides = Array.from(gallery.querySelectorAll('[data-product-slide]'));
      const thumbs = Array.from(gallery.querySelectorAll('[data-product-thumb]'));
      const prev = gallery.querySelector('[data-product-gallery-prev]');
      const next = gallery.querySelector('[data-product-gallery-next]');
      if (slides.length < 2) return;

      let index = 0;

      const goTo = (nextIndex) => {
        const total = slides.length;
        index = ((nextIndex % total) + total) % total;

        slides.forEach((slide, i) => {
          const active = i === index;
          slide.classList.toggle('is-active', active);
          slide.hidden = !active;
        });

        thumbs.forEach((thumb, i) => {
          const active = i === index;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-current', active ? 'true' : 'false');
        });
      };

      if (prev) {
        prev.addEventListener('click', () => goTo(index - 1));
      }
      if (next) {
        next.addEventListener('click', () => goTo(index + 1));
      }

      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          const thumbIndex = Number(thumb.getAttribute('data-slide-index'));
          if (Number.isNaN(thumbIndex)) return;
          goTo(thumbIndex);
        });
      });

      gallery.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          goTo(index - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          goTo(index + 1);
        }
      });
    });
  })();

  (() => {
    const sellingPlanGroups = document.querySelectorAll('[data-selling-plan-group]');
    if (!sellingPlanGroups.length) return;

    sellingPlanGroups.forEach((fieldset) => {
      const form = fieldset.closest('form');
      if (!form) return;

      const info = form.closest('.product-main__info');
      const priceEl = info ? info.querySelector('[data-product-price]') : null;
      const paymentButton = form.querySelector('[data-shopify="payment-button"]');
      const radios = fieldset.querySelectorAll('input[name="selling_plan"]');

      radios.forEach((radio) => {
        radio.addEventListener('change', () => {
          if (priceEl && radio.dataset.sellingPlanPrice) {
            priceEl.textContent = radio.dataset.sellingPlanPrice;
          }
          if (paymentButton) {
            paymentButton.hidden = radio.value !== '';
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["story-panels"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initStoryPanels(root) {
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-motion-item]'));
      if (!items.length) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        items.forEach(function (item) { item.classList.add('is-visible'); });
        return;
      }

      root.classList.add('story-panels--motion-ready');

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, {
        rootMargin: '0px 0px -18% 0px',
        threshold: 0.28
      });

      items.forEach(function (item) { observer.observe(item); });
    }

    document.querySelectorAll('[data-story-panels]').forEach(initStoryPanels);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var PREV = 'is-prev';
    var ACTIVE = 'is-active';
    var NEXT = 'is-next';

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    document.querySelectorAll('[data-testimonials]').forEach(function (root) {
      var slides = Array.prototype.slice.call(root.querySelectorAll('[data-testimonial-slide]'));
      var total = slides.length;
      if (total < 3) return;

      var activeIndex = 1;
      var intervalMs = parseInt(root.getAttribute('data-interval-ms'), 10);
      if (isNaN(intervalMs) || intervalMs < 2000) intervalMs = 4000;
      var timer = null;
      var liveRegion = root.querySelector('[data-testimonials-live]');

      function wrap(i) {
        return (i + total) % total;
      }

      function applyPositions() {
        var prevIdx = wrap(activeIndex - 1);
        var nextIdx = wrap(activeIndex + 1);

        slides.forEach(function (slide, i) {
          slide.classList.remove(PREV, ACTIVE, NEXT);
          slide.setAttribute('aria-hidden', 'true');

          if (i === prevIdx) {
            slide.classList.add(PREV);
          } else if (i === activeIndex) {
            slide.classList.add(ACTIVE);
            slide.setAttribute('aria-hidden', 'false');
          } else if (i === nextIdx) {
            slide.classList.add(NEXT);
          }
        });

        if (liveRegion) {
          var activeSlide = slides[activeIndex];
          var quote = activeSlide.querySelector('.testimonial-card__quote');
          var author = activeSlide.querySelector('.testimonial-card__author');
          liveRegion.textContent = (quote ? quote.textContent : '') + (author ? ' — ' + author.textContent : '');
        }
      }

      function goTo(i) {
        activeIndex = wrap(i);
        applyPositions();
      }

      function startAutoplay() {
        if (prefersReducedMotion()) return;
        stopAutoplay();
        timer = setInterval(function () {
          if (!document.hidden) goTo(activeIndex + 1);
        }, intervalMs);
      }

      function stopAutoplay() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      var prevBtn = root.querySelector('[data-testimonials-prev]');
      var nextBtn = root.querySelector('[data-testimonials-next]');

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          goTo(activeIndex - 1);
          stopAutoplay();
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          goTo(activeIndex + 1);
          stopAutoplay();
        });
      }

      root.addEventListener('mouseenter', stopAutoplay);
      root.addEventListener('mouseleave', startAutoplay);
      root.addEventListener('focusin', stopAutoplay);
      root.addEventListener('focusout', function (e) {
        if (!root.contains(e.relatedTarget)) startAutoplay();
      });

      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') { goTo(activeIndex - 1); stopAutoplay(); }
        if (e.key === 'ArrowRight') { goTo(activeIndex + 1); stopAutoplay(); }
      });

      var touchStartX = null;
      root.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].clientX;
      }, { passive: true });

      root.addEventListener('touchend', function (e) {
        if (touchStartX === null) return;
        var delta = e.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        if (Math.abs(delta) < 50) return;
        if (delta < 0) {
          goTo(activeIndex + 1);
        } else {
          goTo(activeIndex - 1);
        }
        stopAutoplay();
      }, { passive: true });

      root.addEventListener('shopify:section:unload', stopAutoplay);

      applyPositions();
      startAutoplay();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
